// Shared spec field definitions for product forms (upload review + edit)
export const NUM_FIELDS = [
  ["price_per_kg", "pricePerKg"], ["consumption_kg_per_m2", "consumption"],
  ["bag_weight_kg", "bagWeight"],
  ["yield_m2_per_bag", "resa"], ["bags_per_pallet", "bagsPerPallet"],
  ["acqua_min_l", "acqua"], ["acqua_max_l", "acqua"],
  ["spessore_min_mm", "spessore"], ["spessore_max_mm", "spessore"],
  ["lavorabilita_min", "lavorabilita"], ["pedonabile_ore", "pedonabile"],
  ["densita_kg_dm3", "densita"], ["mani_prodotto", "maniProdotto"],
  ["attesa_piastrelle_giorni", "attesaPiastrelle"], ["attesa_parquet_giorni", "attesaParquet"],
  ["allungamento_pct", "allungamento"],
  ["consumo_teorico_mm", "consumoTeoricoMm"], ["coef_denti", "coefDenti"], ["coef_inclinazione", "coefInclinazione"],
];

export const TXT_FIELDS = [
  ["resistenza", "resistenza"], ["certificazioni", "certificazioni"], ["colore", "colore"],
  ["classe_ripristino", "classeRipristino"],
];

export const BOOL_FIELDS = [
  "interno", "esterno", "serpentine", "rapida", "ceramica", "mosaico",
  "pietra_naturale", "parquet", "pareti", "pavimenti", "soffitto",
];

export function numLabel(t, key, labelKey) {
  let label = t(labelKey);
  if (key.endsWith("_min_l") || key.endsWith("_min_mm")) label += " (min)";
  if (key.endsWith("_max_l") || key.endsWith("_max_mm")) label += " (max)";
  return label;
}
